import { render, staticRenderFns } from "./StudentAnswerViewer.vue?vue&type=template&id=0028230a&scoped=true&"
import script from "./StudentAnswerViewer.vue?vue&type=script&lang=js&"
export * from "./StudentAnswerViewer.vue?vue&type=script&lang=js&"
import style0 from "./StudentAnswerViewer.vue?vue&type=style&index=0&id=0028230a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0028230a",
  null
  
)

export default component.exports